import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { translate } from "react-i18next";
import compose from "ramda/src/compose";
import {
  Form,
  Button,
  FloatLabelInput,
  FloatLabelSelect,
  FloatLabelTextArea,
} from "shared/components";
import Loader from "../../../../components/Loading";
import styles from "../../styles.css";
import * as Mask from "../../../../services/utils/mask";
import { createCommonIncident } from "../../../../services/state/actions";
import { THE_FAILURE_AFFECTS } from "services/state/repair/constants";
import {
  isRequired,
  isTime,
  isPhone,
  isValidDate,
} from "services/utils/validation";

class CallingProblemForm extends Component {
  state = {
    isOpenProducts: this.props.isOpen,
    products: null,
    circuit: null,
  };

  onSubmit = (form) => {
    const { t, reason, createCommonIncident, onNextStep, onReset } = this.props;

    const checklist = {
      data: { ...form, reason },
      labels: {
        key: t("MSG_0281"),
        contactPhone: t("MSG_0206"),
        timeSlot: t("MSG_0205"),
        description: t("MSG_0202"),
        failureAffects: t("FAILURE_AFFECTS"),
        failureDate: t("FAILURE_DATE"),
        failureTime: t("FAILURE_TIME"),
        gmt: t("GMT"),
        reason: t("MSG_0309"),
        calledNumbers: t("MSG_0284"),
        problemType: t("MSG_0310"),
      },
    };

    return createCommonIncident(checklist, onNextStep, onReset);
  };

  renderInputField(field) {
    const {
      meta: { touched, error, invalid },
    } = field;

    return (
      <FloatLabelInput
        {...field.input}
        id={field.id}
        type={field.type ? field.type : "text"}
        label={field.label}
        maxLength={field.id === "contactPhone" ? "15" : ""}
        invalid={touched && invalid}
        error={error}
        value={field.input.value ? field.input.value : ""}
      />
    );
  }

  renderTextAreaField(field) {
    return (
      <FloatLabelTextArea
        id={field.id}
        name={field.name}
        noResize
        label={field.label}
        preset="modalTextArea"
        onChange={field.input.onChange}
        value={field.input.value ? field.input.value : ""}
      />
    );
  }

  renderSelectField(field) {
    const {
      meta: { touched, error, invalid },
    } = field;

    return (
      <FloatLabelSelect
        id={field.id}
        options={field.options}
        label={field.label}
        invalid={touched && invalid}
        error={error}
        defaultOption
        {...field.input}
      />
    );
  }

  render() {
    const {
      t,
      handleSubmit,
      submitting,
      onPreviousStep,
      hasFailureDate,
    } = this.props;

    return (
      <Fragment>
        <span>{t("MSG_0211")}</span>
        <Form onSubmit={handleSubmit(this.onSubmit)}>
          <Field
            id="keyVoice"
            label={t("MSG_0281")}
            name="key"
            component={this.renderInputField}
            validate={[isRequired]}
            format={Mask.phone}
            normalize={Mask.algarPhone}
          />

          <Field
            id="description"
            label={t("MSG_0202")}
            maxLength={500}
            name="description"
            component={this.renderTextAreaField}
            validate={[isRequired]}
          />

          <Field
            id="failureAffects"
            label={t("FAILURE_AFFECTS")}
            name="failureAffects"
            component={this.renderSelectField}
            options={THE_FAILURE_AFFECTS}
            validate={[isRequired]}
          />

          {hasFailureDate && (
            <Fragment>
              <Field
                id="failureDate"
                label={t("FAILURE_DATE")}
                name="failureDate"
                component={this.renderInputField}
                normalize={Mask.date}
                format={Mask.date}
                validate={[isRequired, isValidDate]}
              />

              <Field
                id="failureTime"
                label={t("FAILURE_TIME")}
                name="failureTime"
                component={this.renderInputField}
                normalize={Mask.time}
                format={Mask.time}
                validate={[isRequired]}
              />

              <Field
                id="gmt"
                label={t("GMT")}
                name="gmt"
                component={this.renderInputField}
                validate={[isRequired]}
              />
            </Fragment>
          )}

          <Field
            id="calledNumbers"
            type="text"
            label={t("MSG_0284")}
            name="calledNumbers"
            component={this.renderInputField}
            validate={[isRequired]}
          />

          <Field
            id="reason"
            type="text"
            label={t("MSG_0309")}
            name="reason"
            component={this.renderInputField}
            validate={[isRequired]}
          />

          <Field
            id="problemType"
            type="text"
            label={t("MSG_0310")}
            name="problemType"
            component={this.renderInputField}
            validate={[isRequired]}
          />

          <Field
            id="timeSlot"
            type="text"
            label={t("MSG_0205")}
            name="timeSlot"
            component={this.renderInputField}
            format={Mask.timeRange}
            normalize={Mask.timeRange}
            validate={[isRequired, isTime]}
          />

          <Field
            id="contactPhone"
            type="text"
            label={t("MSG_0206")}
            name="contactPhone"
            component={this.renderInputField}
            format={Mask.phone}
            normalize={Mask.algarPhone}
            validate={[isRequired, isPhone]}
          />

          <div className={styles.actions}>
            <Button onClick={onPreviousStep} relevance="low">
              {t("MSG_0292")}
            </Button>

            <Button type="submit" relevance="normal" callToAction>
              {t("MSG_0007")}
            </Button>
          </div>
        </Form>

        <Loader isOpen={submitting} />
      </Fragment>
    );
  }
}

const reduxFormConfig = {
  form: "CallingProblemForm",
};

const enhance = compose(
  translate(),
  connect(null, { createCommonIncident }),
  reduxForm(reduxFormConfig)
);

export default enhance(CallingProblemForm);



// WEBPACK FOOTER //
// ./src/components/RepairWizard/components/ModalTotalVoice/CallingProblemForm.js